import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { SHOP_CURRENT_ROUTE } from '../../utils/constants';
import { ApiKeysSettingsPage } from './pages/ApiKeysSettingsPage';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/api-keys`,
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <ApiKeysSettingsPage />,
            },
        ],
    },
];

export default routes;
